import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCouponFilled = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      d="M18.347 15.152v.505q0 .331.158.625.164.294.589.294t.579-.29a1.3 1.3 0 0 0 .159-.63v-.504q0-.34-.15-.635-.15-.294-.588-.294-.42 0-.584.294a1.3 1.3 0 0 0-.164.635M13.448 9.679v.504q0 .341.158.63.164.29.575.29.428 0 .584-.29a1.3 1.3 0 0 0 .158-.63v-.504q0-.342-.15-.636-.148-.294-.592-.294-.416 0-.575.3-.159.298-.159.63"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M6.224 4.667H2.63a2 2 0 0 0-2 2v3a3 3 0 1 1 0 6v3a2 2 0 0 0 2 2h3.594v-2H7.63v2h15a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-15v2H6.224zm1.406 9v3H6.224v-3zm0-5v3H6.224v-3zm9.358 6.99v-.505q0-.575.242-1.055.248-.486.715-.776.471-.294 1.149-.294.686 0 1.153.29.472.29.71.775.243.48.243 1.06v.505q0 .573-.243 1.06-.243.48-.714.77-.472.294-1.15.294-.685 0-1.153-.294a1.9 1.9 0 0 1-.71-.77 2.34 2.34 0 0 1-.242-1.06m-4.909-5.474v-.504q0-.58.248-1.06.248-.486.714-.776.472-.29 1.14-.29.69 0 1.158.29t.71.776q.243.48.243 1.06v.504q0 .58-.248 1.06-.243.481-.715.77-.466.285-1.148.286-.683 0-1.154-.29a1.94 1.94 0 0 1-.71-.77 2.35 2.35 0 0 1-.238-1.056m.617 7.267 6.575-9.565h1.224l-6.576 9.565z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCouponFilled);
export default Memo;
